module.exports = __webpack_public_path__ + "media/images/errorpage-graphic-1f0970398c8fb44ee9622e1d85587b53.png";